module.exports = __webpack_public_path__ + "840ace132382000ec18476111effc8db.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-stripes-gray-s.png
// module id = 1379
// module chunks = 0